import { useMemo } from 'react'
import { SmallLocationCardProps } from '../SmallLocationCard'
import { useDeleteDialog } from './useDeleteDialog'
import { useForm } from './useForm'

export function useActions(params: SmallLocationCardProps) {
  const {
    location: { billingLocation, externalLinkId, locationCode },
  } = params

  const matched = Boolean(externalLinkId) && Boolean(locationCode)
  const { editMenuOption, formProps } = useForm(params, matched)
  const { deleteMenuOption, deleteDialogProps } = useDeleteDialog(
    params,
    matched,
  )

  const menuOptions = useMemo(() => {
    return matched
      ? billingLocation
        ? []
        : [{ ...deleteMenuOption, dataTestId: 'billing-location-delete-btn' }]
      : billingLocation
        ? [{ ...editMenuOption, dataTestId: 'billing-location-edit-btn' }]
        : [
            { ...editMenuOption, dataTestId: 'billing-location-edit-btn' },
            {
              ...deleteMenuOption,
              dataTestId: 'billing-location-delete-btn',
            },
          ]
  }, [billingLocation, deleteMenuOption, editMenuOption, matched])

  return {
    menuOptions,
    formProps,
    deleteDialogProps,
    matched,
  }
}
